import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LinGuard} from './utils/guards/lin-guard/lin.guard';
import {AuthGuard} from './utils/guards/auth-guard/auth.guard';
import {CompatibilityGuard} from './utils/guards/compatibility-guard/compatibility.guard';

const routes: Routes = [
  {path: '', redirectTo: '/app/lin/start/startpage', pathMatch: 'full'},
  {path: 'auth', loadChildren: () => import('./app-sections/auth/auth.module').then(m => m.AuthModule)},
  {
    path: 'app',
    canActivate: [AuthGuard, CompatibilityGuard],
    children: [
      {path: 'customer', loadChildren: () => import('./app-sections/customer-root/customer-root.module').then(m => m.CustomerRootModule)},
      {path: 'lin', canActivate: [LinGuard], loadChildren: () => import('./app-sections/lin-root/lin-root.module').then(m => m.LinRootModule)}
  ]
  },
  {
    path: 'misc',
    loadChildren: () => import('./app-sections/misc/misc.module').then(m => m.MiscModule)
  },
  {
    path: 'public',
    loadChildren: () => import('./app-sections/public/public.module').then(m => m.PublicModule)
  },
  {
    path: 'google',loadChildren: () =>import('./app-sections/google/google.module').then(m => m.GoogleModule)
  },
  {path: '**', redirectTo: '/misc/404'}, 
];

// Debug: enableTracing: true
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
